
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indext_Uq2PSonE1sf9kLX6YXnEHIH_KLZWQgRl3qV_ceTFcMeta } from "/Users/sebasgona/sga/pinturas-granados/granados/app/pages/index.vue?macro=true";
import { default as contactosjKEX3pLTm_458yqGM1llATSYLUzHZk3yFY_459tRTkf0u4Meta } from "/Users/sebasgona/sga/pinturas-granados/granados/app/pages/contacto.vue?macro=true";
import { default as indexPgR_45_e9G_j7OFP3pvqeQ3gWQl8NTx_458J0gs5Nl1EH_AMeta } from "/Users/sebasgona/sga/pinturas-granados/granados/app/pages/catalogo/index.vue?macro=true";
import { default as _91slug_932_qgc3OjsKdX2IbBC_xQQ6t9SfQYViFIFCRgM_R8xJIMeta } from "/Users/sebasgona/sga/pinturas-granados/granados/app/pages/catalogo/[slug].vue?macro=true";
import { default as indexYhAFTX9inrl2rSDCyOjo3gF2T_b2FpUTi4_45r2LWR9DQMeta } from "/Users/sebasgona/sga/pinturas-granados/granados/app/pages/[category]/index.vue?macro=true";
import { default as index5VsqwGSk6X2Mf8Jrao0lYJ6jYpsoaHCv2PXsnsBGozcMeta } from "/Users/sebasgona/sga/pinturas-granados/granados/app/pages/cotizacion/index.vue?macro=true";
import { default as _91quoteNumber_93547ZtaWz_j5saR5okjpVnPZAZOp4FtzFAgMTPFVU7iAMeta } from "/Users/sebasgona/sga/pinturas-granados/granados/app/pages/cotizacion/[quoteNumber].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/Users/sebasgona/sga/pinturas-granados/granados/app/pages/index.vue")
  },
  {
    name: "contacto",
    path: "/contacto",
    component: () => import("/Users/sebasgona/sga/pinturas-granados/granados/app/pages/contacto.vue")
  },
  {
    name: "catalogo",
    path: "/catalogo",
    component: () => import("/Users/sebasgona/sga/pinturas-granados/granados/app/pages/catalogo/index.vue")
  },
  {
    name: "catalogo-slug",
    path: "/catalogo/:slug()",
    component: () => import("/Users/sebasgona/sga/pinturas-granados/granados/app/pages/catalogo/[slug].vue")
  },
  {
    name: "category",
    path: "/:category()",
    meta: {"middleware":"category"},
    component: () => import("/Users/sebasgona/sga/pinturas-granados/granados/app/pages/[category]/index.vue")
  },
  {
    name: "cotizacion",
    path: "/cotizacion",
    component: () => import("/Users/sebasgona/sga/pinturas-granados/granados/app/pages/cotizacion/index.vue")
  },
  {
    name: "cotizacion-quoteNumber",
    path: "/cotizacion/:quoteNumber()",
    component: () => import("/Users/sebasgona/sga/pinturas-granados/granados/app/pages/cotizacion/[quoteNumber].vue")
  }
]